import type { ReactNode } from 'react';
import React, { createContext, useContext, useState } from 'react';

// Define the context and the type for the context state
interface TextAreaContextType {
  text: string;
  setText: (newText: string) => void;
  appendDiagnosis: (diagnosisText: string) => void; // Function to append diagnosis to the existing text
}

const TextAreaContext = createContext<TextAreaContextType | undefined>(
  undefined
);

// Provider component
export const TextAreaProvider = ({ children }: { children: ReactNode }) => {
  const [text, setText] = useState(''); // State for managing the textarea content

  // Function to append a new diagnosis to the existing text
  const appendDiagnosis = (diagnosisText: string) => {
    setText((prevText) => `${prevText}${diagnosisText}`);
  };

  return (
    <TextAreaContext.Provider value={{ text, setText, appendDiagnosis }}>
      {children}
    </TextAreaContext.Provider>
  );
};

// Custom hook to access the context
export const useTextArea = () => {
  const context = useContext(TextAreaContext);
  if (!context) {
    throw new Error('useTextArea must be used within a TextAreaProvider');
  }
  return context;
};
